import { render, staticRenderFns } from "./PageImportAllergenes.vue?vue&type=template&id=69ff62ce&"
import script from "./PageImportAllergenes.vue?vue&type=script&lang=js&"
export * from "./PageImportAllergenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports